/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */
import type { ImageGenerationUpdatedImage } from "./ImageGenerationUpdatedImage";
import type { ImageGenerationUpdatedPayloadSideEffectType } from "./ImageGenerationUpdatedPayloadSideEffectType";

export interface ImageGenerationUpdatedPayload {
  side_effect_type: ImageGenerationUpdatedPayloadSideEffectType;
  conversation_id: string;
  event_id: string;
  images: ImageGenerationUpdatedImage[];
}
